module.exports = __webpack_public_path__ + "img/CO.7180bb33.png";